import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalHostTerminalTable } from "./TerminalHostTerminalTable";

export const TerminalHostTerminalTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <TerminalHostTerminalTable key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
